// import constant
import {
  SET_LOGGED_IN_USER,
  REMOVE_LOGGED_IN_USER,
  SET_LOGGED_USER_DATA,
  MOBILE_NUMBER_ACTION,
  USER_WALLET_ACTIONS,
  RELOAD_WALLET_ACTIONS,
  TON_LOGGED_ACTION,
  RELOAD_API_AFTER_BET_ACTIONS,
  APP_LANCHED_ACTION,
  CONNECT_WALLET_TOGGLE_ACTION,
  SET_USER_BALANCE,
} from "../constant";
import {
  setAuthUser,
  removeAuthUser,
  setLoggedUser,
  appLanched,
} from "core/helper/localstorage";



const initialState = {
  isLoggedIn: false,
  token: "",
  authUser: "",
  profile: null,
  coin: 0,
  mobileNumber: "",
  wallet: null,
  reloadWallet: false,
  isLoggedTon: false,
  reloadApi: false,
  appLaunched: false,
  connectWalletTogg: false,
  userBalance:[]
};

const account = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case MOBILE_NUMBER_ACTION:
      return {
        ...state,
        ...payload,
      };
    case SET_LOGGED_IN_USER:
      setAuthUser(payload);
      return {
        ...state,
        authUser: payload,
      };
    case CONNECT_WALLET_TOGGLE_ACTION:
      return {
        ...state,
        connectWalletTogg: payload,
      };
    case APP_LANCHED_ACTION:
      appLanched(payload);
      return {
        ...state,
        ...payload,
      };
    case REMOVE_LOGGED_IN_USER:
      removeAuthUser();
      return {
        ...state,
        ...payload,
      };
    case SET_LOGGED_USER_DATA:
      setLoggedUser(payload);
      return {
        ...state,
        profile: payload,
      };
    case USER_WALLET_ACTIONS:
      return {
        ...state,
        wallet: payload,
      };
    case RELOAD_WALLET_ACTIONS:
      return {
        ...state,
        reloadWallet: payload,
      };
    case RELOAD_API_AFTER_BET_ACTIONS:
      return {
        ...state,
        reloadApi: !state.reloadApi,
      };
    case TON_LOGGED_ACTION:
      return {
        ...state,
        isLoggedTon: payload,
      };
    case SET_USER_BALANCE:
      return {
        ...state,
        userBalance: payload,
      };
    default:
      return state;
  }
};

export default account;
